import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Input from '../Input';
import Button from '../Button';
import Styles from './styled';
import getQueryParams from '../../../util/getQueryParams';
import submitMarketingForm from '../../../services/submitMarketingForm';
import noop from '../../../util/noop';

const EmailSignup = ({
  buttonLabel = 'Subscribe',
  originCampaign = '',
  originWebApp = '',
  originWebFormCategory = '',
  originWebFormType = '',
  originWebPageType = '',
  dataExtension = '',
  onEmailSubmit = noop,
  className = '',
}) => {
  const [submitted, setSubmitted] = useState(false);
  const onSubmit = (_values, { setSubmitting, setStatus }) => {
    const queryParams = getQueryParams(window.location.search);
    const tracker = window?.ga?.getAll ? window?.ga?.getAll()?.[0] : false;
    const clientId = tracker ? tracker?.get('clientId') : '';

    const values = {
      ..._values,
      originWebApp,
      originWebPageType,
      originWebFormType,
      originCampaign,
      originWebFormCategory,
      dataExtension,
      canEmail: true,
      doNotCall: false,
      originWebUrl: window.location.href,
      originWebAppType: '',
      utmSource: queryParams?.utm_source || '',
      utmCampaign: queryParams?.utm_campaign || '',
      utmTerm: queryParams?.utm_term || '',
      utmContent: queryParams?.utm_content || '',
      utmMedium: queryParams?.utm_medium || '',
      kenshooId: queryParams?.kenshooid || '',
      gaClientId: clientId,
      gaClickId: queryParams?.gclid || '',
      fbClickId: queryParams?.fbclid || '',
    };

    submitMarketingForm(values)
      .then(response => {
        setSubmitted(true);
        setSubmitting(false);
      })
      .catch(err => {
        setStatus(err);
        setSubmitting(false);
        console.error(err);
      });

    onEmailSubmit();
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    errors,
    touched,
    values,
    status,
    isSubmitting,
  } = useFormik({
    initialValues: {
      emailAddress: '',
    },
    validationSchema: Yup.object().shape({
      emailAddress: Yup.string()
        .email('You must enter a valid email.')
        .required('Email is required'),
    }),
    onSubmit,
  });

  if (status) {
    return (
      <p className='type-h4'>
        Uh oh, looks like we've encountered an error. Please try again later.
      </p>
    );
  }

  if (submitted) {
    return <p className='type-h4'>Thanks for subscribing!</p>;
  }

  return (
    <Styles onSubmit={handleSubmit}>
      <fieldset disabled={isSubmitting} aria-label='Email Signup'>
        <legend>Email signup form</legend>
        <Input
          type='text'
          label='Email address'
          name='emailAddress'
          value={values.emailAddress}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors?.emailAddress}
          touched={touched?.emailAddress}
        />
      </fieldset>
      <Button
        type='submit'
        size='small'
        disabled={isSubmitting}
        className={className}
      >
        {buttonLabel}
      </Button>
    </Styles>
  );
};

EmailSignup.propTypes = {
  buttonLabel: PropTypes.string,
  originCampaign: PropTypes.string,
  originWebApp: PropTypes.string,
  originWebFormCategory: PropTypes.string,
  originWebFormType: PropTypes.string,
  originWebPageType: PropTypes.string,
  dataExtension: PropTypes.string,
  onEmailSubmit: PropTypes.func,
};

export default EmailSignup;
